export const NEW_LINE = '\n';
export const OUTLOOK_NEW_LINE = '\r\n';
export const WEB_NEW_LINE = '<br>';
export const DEFAULT_MEETING_DURATION = 30;
// Minimum Mailbox version required by officeJS to load and run Outlook plugin properly.
export const MAILBOX_VERSION_1_5 = '1.5';

/**
 * Formats line wraps, indentation and other for formatting for
 * email invite text in use iw web based meeting invite
 */
export const formatInviteMessageBodyForWeb = (bodyString: string) => {
  let result = '';
  if (!!bodyString) {
    const individualLines = bodyString.split('\n');
    let lastString = '';
    individualLines.forEach((arg) => {
      // Look for ident on left using blank spaces
      let formattedLine = arg.trimRight().replace('    ', '&nbsp;&nbsp;');
      // Empty lines are treated as an extra return
      if (formattedLine === '') {
        formattedLine = WEB_NEW_LINE;
      }
      result += (lastString && lastString.trim().length ? WEB_NEW_LINE : '') + (formattedLine || '');
      lastString = arg;
    });
  }
  return result;
};

export const outlookNewlineJoin = (isOfficeForWeb: boolean, ...args: any[]) => {
  let result = '';
  let lastString = '';
  const newLine = isOfficeForWeb ? WEB_NEW_LINE : OUTLOOK_NEW_LINE;
  args.forEach((arg) => {
    result += (lastString && lastString.trim().length ? newLine + newLine : '') + (arg || '');
    lastString = arg;
  });
  return result;
};

export const isMailBoxVersionSupported = (version: string) =>
  Office.context.requirements.isSetSupported('Mailbox', version);
